export default ".grid {\n  display: grid;\n}";